import React, { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import { useAuthContext } from "../contexts/auth";
import { PaperSection } from "../components/PaperSection";
import FeedbackWidget from "../components/FeedbackWidget";
import RoadmapItem from "../components/RoadmapItem";
import FeatureRequestModal from "../components/FeatureRequestModal";
import { useRoadmap } from "../hooks/useRoadmap";

export default function Roadmap() {
  const { session } = useAuthContext();
  const [showRequestModal, setShowRequestModal] = useState(false);
  
  const {
    inProgressItems,
    plannedItems,
    completedItems,
    loading,
    error,
    voteForItem,
    refreshRoadmap
  } = useRoadmap();

  return (
    <Layout>
      <div className="space-y-4 sm:space-y-6 px-4 sm:px-0 pb-20">
        <div>
          <h1 className="text-2xl sm:text-3xl font-display page-title">
            What's Next?
          </h1>
          <p className="text-gray-600 mt-1 text-sm sm:text-base">
            View our upcoming features and vote on what matters most to you.
          </p>
        </div>

        {error ? (
          <PaperSection variant="super-heavy" className="border-l-4 border-red-400 text-red-600">
            <p>Error: {error}</p>
            <button
              onClick={refreshRoadmap}
              className="mt-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-haus-dark-brown/10 hover:bg-haus-dark-brown/20 rounded transition-colors text-sm"
              aria-label="Try loading roadmap again"
            >
              Try Again
            </button>
          </PaperSection>
        ) : loading ? (
          <div className="flex justify-center items-center py-10">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            {/* In Progress Section - Only show if has items */}
            {inProgressItems.length > 0 && (
              <PaperSection variant="super-heavy" className="p-4 sm:p-6">
                <h2 className="text-xl font-display mb-4">In Progress</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {inProgressItems.map(item => (
                    <RoadmapItem 
                      key={item.id} 
                      item={item} 
                      onVote={voteForItem} 
                    />
                  ))}
                </div>
              </PaperSection>
            )}

            {/* Planned Section - Only show if has items */}
            {plannedItems.length > 0 && (
              <PaperSection variant="super-heavy" className="p-4 sm:p-6">
                <h2 className="text-xl font-display mb-4">Planned</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {plannedItems.map(item => (
                    <RoadmapItem 
                      key={item.id} 
                      item={item} 
                      onVote={voteForItem} 
                    />
                  ))}
                </div>
              </PaperSection>
            )}
            
            {/* Completed Section - Only show if has items */}
            {completedItems.length > 0 && (
              <PaperSection variant="super-heavy" className="p-4 sm:p-6">
                <h2 className="text-xl font-display mb-4">Recently Completed</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {completedItems.slice(0, 4).map(item => (
                    <RoadmapItem 
                      key={item.id} 
                      item={item} 
                      onVote={voteForItem} 
                    />
                  ))}
                </div>
              </PaperSection>
            )}
          </>
        )}
      </div>
      
      {/* Feature Request CTA - Floating at bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-30 px-4 pb-4 pointer-events-none">
        <div className="max-w-4xl mx-auto md:pl-20 pointer-events-auto">
          <PaperSection variant="super-heavy" className="p-4 sm:p-6 border border-haus-light-black border-l-4 border-l-haus-dark-green shadow-lg">
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <div>
                <h3 className="font-medium text-lg">Can't find what you're looking for?</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Tell us what feature you'd like to see next.
                </p>
              </div>
              <button
                onClick={() => setShowRequestModal(true)}
                className="mt-3 sm:mt-0 px-4 py-2 bg-haus-dark-green text-white rounded hover:bg-haus-light-olive transition-colors"
              >
                Request a Feature
              </button>
            </div>
          </PaperSection>
        </div>
      </div>
      
      {/* Feature Request Modal */}
      <FeatureRequestModal 
        isOpen={showRequestModal}
        onClose={() => setShowRequestModal(false)}
      />
      
      <FeedbackWidget />
    </Layout>
  );
} 